import { Button, Card, FieldError, Input, Label, TextField } from "@heroui/react";
import { Controller } from "react-hook-form";
import { useLogin } from "@/src/auth/hooks/use-login";
import { env } from "@/src/common/constants/env";

const LoginPage: React.FC = () => {
	const {
		step,
		email,
		devCode,
		cooldown,
		error,
		emailForm,
		codeForm,
		onSubmitEmail,
		onSubmitCode,
		resend,
		backToEmail,
		isRequesting,
		isVerifying,
	} = useLogin();

	return (
		<main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-4 py-8">
			<div className="flex flex-col items-center gap-1">
				<span className="text-2xl font-bold tracking-tight text-foreground">{env.APP_NAME}</span>
				<span className="text-sm text-muted">Back-office</span>
			</div>

			<Card className="w-full max-w-md bg-surface">
				<Card.Header>
					<Card.Title>Connexion admin</Card.Title>
					<Card.Description>{step === "email" ? "Entrez votre email pour recevoir un code." : `Code envoyé à ${email}.`}</Card.Description>
				</Card.Header>
				<Card.Content>
					{error ? <p className="mb-4 rounded-lg border border-border-soft bg-glass p-3 text-center text-sm text-danger">{error}</p> : null}

					{step === "email" ? (
						<form onSubmit={onSubmitEmail} className="flex flex-col gap-4">
							<Controller
								control={emailForm.control}
								name="email"
								render={({ field, fieldState }) => (
									<TextField isInvalid={Boolean(fieldState.error)} value={field.value} onChange={field.onChange} onBlur={field.onBlur}>
										<Label>Email</Label>
										<Input type="email" autoComplete="email" placeholder="vous@storyline.app" />
										<FieldError>{fieldState.error?.message}</FieldError>
									</TextField>
								)}
							/>
							<Button type="submit" isDisabled={isRequesting} className="w-full">
								{isRequesting ? "Envoi…" : "Recevoir le code"}
							</Button>
						</form>
					) : (
						<form onSubmit={onSubmitCode} className="flex flex-col gap-4">
							{devCode ? (
								<p className="rounded-lg border border-accent-soft bg-accent-soft p-3 text-center text-sm text-accent-lav">
									Code de développement : <span className="font-semibold">{devCode}</span>
								</p>
							) : null}
							<Controller
								control={codeForm.control}
								name="code"
								render={({ field, fieldState }) => (
									<TextField isInvalid={Boolean(fieldState.error)} value={field.value} onChange={field.onChange} onBlur={field.onBlur}>
										<Label>Code de vérification</Label>
										<Input inputMode="numeric" autoComplete="one-time-code" placeholder="000000" />
										<FieldError>{fieldState.error?.message}</FieldError>
									</TextField>
								)}
							/>
							<Button type="submit" isDisabled={isVerifying} className="w-full">
								{isVerifying ? "Vérification…" : "Se connecter"}
							</Button>
							<div className="flex items-center justify-between text-sm">
								<Button variant="ghost" onPress={backToEmail} className="px-0 text-muted">
									Changer d'email
								</Button>
								<Button variant="ghost" isDisabled={cooldown > 0} onPress={() => void resend()} className="px-0 text-accent-lav">
									{cooldown > 0 ? `Renvoyer (${cooldown}s)` : "Renvoyer le code"}
								</Button>
							</div>
						</form>
					)}
				</Card.Content>
			</Card>
		</main>
	);
};

export default LoginPage;
